@if (xploreItemDTO) {
  <app-xplore-page
    [xploreItem]="xploreItemDTO">
  </app-xplore-page>
}

@if (xploreItemDTO === null) {
  <div class="flex height-without-bar align-items-center justify-content-center">
    <h1 class="text-lg">Attendo l'arrivo dei dati della preview</h1>
  </div>
}
